module.exports = __webpack_public_path__ + "static/media/prizyvanetlogo.054ac678.png";